export default __webpack_public_path__ + "static/media/logo.a2de1beb.svg";